import React, { useState, useEffect } from 'react'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import PageHeader from '@shared/PageHeader'
import ShelveBatchNewForm from '@shared/shelves/ShelveBatchNewForm'
import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import { operatorService } from '@services/operator/operatorService'
import { shelfService } from '@services/operator/shelfService'

export default function OperatorShelvesBatchNew() {
  const { t } = useTranslation()
  const { shelfTypes } = useOperatorData()
  const { addJob } = useOperatorNotification()
  const [warehouse, setWarehouse] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchWarehouse = async () => {
      try {
        const data = await operatorService.getCurrent()
        if (data.success && data.data?.warehouse) {
          setWarehouse(data.data.warehouse)
        }
      } catch (error) {
        console.error('Failed to fetch warehouse:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchWarehouse()
  }, [])

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />
  }

  return (
    <div>
      <PageHeader items={['stocks', 'stocks.shelves', { label: t('shared.shelves.batch_new.title') }]} />
      <ShelveBatchNewForm
        shelfService={shelfService}
        role="operator"
        warehouse={warehouse}
        shelfTypes={shelfTypes}
        addBackgroundJob={addJob}
      />
    </div>
  )
}
